import { Text } from '@shopify/polaris';

import { t } from 'react-simple-multi-language';

export const ConfirmationStep = () => {
  return <Text as="p">{t('cancel_modal_description')}</Text>;
};
